// extracted by mini-css-extract-plugin
export var alt = "RequestFolioModal-module--alt--095bd";
export var desktopOnly = "RequestFolioModal-module--desktopOnly--fd722";
export var main = "RequestFolioModal-module--main--39dd7";
export var mobileOnly = "RequestFolioModal-module--mobileOnly--34f66";
export var requestFolioModalstyledDialog = "RequestFolioModal-module--requestFolioModalstyledDialog--efbb5";
export var requestFolioStyleSDialog = "RequestFolioModal-module--requestFolioStyleSDialog--f36d4";
export var textLeft = "RequestFolioModal-module--textLeft--21e92";
export var visuallyHidden = "RequestFolioModal-module--visuallyHidden--95854";